import Vue from 'vue';
import Router from 'vue-router';
// import firebase from '@/helpers/firebase/firebase';

import Home from '@/views/Home.vue';
import DataTable from '@/views/DataTable.vue';
// import SignUp from '@/components/authentication/SignUp';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/datatable',
      name: DataTable.name,
      component: DataTable
    }
    // {
    //   path: '/login',
    //   redirect: '/login',
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: Login,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/invitation',
    //   name: 'invitation',
    //   component: Invitation,
    //   meta: {
    //     requiresAuth: true
    //   }
    // }
    // {
    //   path: '/signup',
    //   name: 'signup',
    //   component: SignUp
    // }
  ]
});

router.beforeEach((to, from, next) => {
  // const IsItABackButton = window.popStateDetected;
  // console.log(to);
  // console.log(from);
  // console.log('hello', IsItABackButton);
  // window.popStateDetected = false;
  // if (IsItABackButton && from.meta.someLogica) {
  //   next(false);
  //   return '';
  // }
  next();
  // const currentUser = firebase.auth().currentUser;
  // const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // if (requiresAuth && !currentUser) next('login');
  // else if (!requiresAuth && currentUser) next('home');
  // else next();
  // next();
});

export default router;
